import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    overflowX: 'clip',
    whiteSpace: 'nowrap',

    '& > div': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  }
}))

export default useStyles
